var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* script */
__vue_exports__ = require("!!babel-loader!../../../node_modules/_vux-loader@1.1.30@vux-loader/src/script-loader.js!vue-loader/lib/selector?type=script&index=0!./loading.vue")

/* template */
var __vue_template__ = require("!!vue-loader/lib/template-compiler?id=data-v-2a4b7995!../../../node_modules/_vux-loader@1.1.30@vux-loader/src/template-loader.js!vue-loader/lib/selector?type=template&index=0!./loading.vue")
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__



//////////////////
// WEBPACK FOOTER
// ./src/components/common/loading.vue
// module id = 378
// module chunks = 15